




























































































import { computed, defineComponent, watch } from '@vue/composition-api';

import CommonUnitSelector from '@/components/Delivery/CommonUnitSelector.vue';
import CommonProductTypeSelect from '../Product/CommonProductTypeSelect.vue';

const ItemOrderForFlatRate = defineComponent({
  components: { CommonUnitSelector, CommonProductTypeSelect },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toDecimalFormat = (string: string, digit = 2) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: digit, maximumFractionDigits: digit });

    function deliveryFeeRateInput($event: any) {
      emit('input', { ...props.value, deliveryFee: $event });
    }
    function itemCountInput($event: any) {
      emit('input', { ...props.value, deliveryFee: (props.value.deliveryFeeRate || 0) * $event });
    }

    return {
      toDecimalFormat,
      deliveryFeeRateInput,
      itemCountInput,
    };
  },
});

export default ItemOrderForFlatRate;
